<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <hr>
        <div class="panel-content" v-if="current">
            <mrDetailedHeader :actions="false" v-if="current" :match="current"></mrDetailedHeader>
            <hr>
            <div class="row columns">
                <div class="row">
                Actions:
                </div>
                <div class="row">
                    <playerReportViewer :match_report="current"></playerReportViewer>
                </div>
                <div v-if="current.home_report.star_report.length > 0 || current.visitor_report.star_report.length > 0">
                    <div class="row">
                    Actions des champions:
                    </div>
                    <div class="row">
                        <starReportViewer :match_report="current"></starReportViewer>
                    </div>
                </div>
            </div>
            <commentPanel :entity_type="mrContentType.id" :entity_id="id"></commentPanel>
            <br>
        </div>
        <div v-else>
            <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import playerReportViewer from './player-report-viewer.vue'
import commentPanel from '../common/comment-panel.vue'
import mrDetailedHeader from './mr-detailed-header.vue'
import starReportViewer from './star-report-viewer.vue'

export default {
  name: 'mrDetail',
  components: {
    spinner,
    playerReportViewer,
    commentPanel,
    mrDetailedHeader,
    starReportViewer
  },
  props: {
    'id': null
  },
  watch: {
    current: function (newMr, oldState) {
      if (newMr.is_db_report) {
        this.$router.push({
          name: 'DBDetail',
          params: {
            id: this.id
          }
        })
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      current: 'detailedMatchReport'
    }),
    mrContentType: function () {
      return store.getters.getContent('league_manager', 'matchreport')
    }

  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('activateFullSizePage')
    store.dispatch('getContentType')
    store.dispatch('getDetailedMatchReport', this.id.toString())
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// mr-detail.vue?c7724b0e